// extracted by mini-css-extract-plugin
module.exports = {"message":"Suggestion_message__3Mve5","show":"Suggestion_show__FdthB"};